import React from 'react';
import { Box, Typography, TextField } from '@mui/material';

const TextareaQuestion = ({ question, questionNumber, onAnswerChange, answer }) => {
  const handleChange = (e) => {
    const value = e.target.value;

    // Only enforce the max character limit while typing
    if (value.length <= question.charLimit.max) {
      onAnswerChange(value);
    }
  };

  const helperText = !answer || answer.length < question.charLimit.min
    ? `Escribe al menos ${question.charLimit.min} caracteres.`
    : `${answer.length}/${question.charLimit.max}`;

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="body1" sx={{ mb: 1 }}>
        {questionNumber !== null && `${questionNumber}.`} {question.text}
      </Typography>
      <TextField
        placeholder={question.placeholder}
        multiline
        rows={4}
        value={answer || ''}
        onChange={handleChange}
        helperText={helperText}
        fullWidth
        slotProps={{input: {readOnly: onAnswerChange === null}}}
      />
    </Box>
  );
};

export default TextareaQuestion;